var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { type: "button" },
            on: { click: _vm.close }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("SUBTITLE.USER.MANAGEMENT.DETAIL")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.GLOBAL.ID")) +
                        "(" +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.EMAIL")) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.email))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.PROFILE.COMPANY.NAME")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.companyName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.NUMBER")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.companyRegNo))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.COMP.ADDR")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.companyAddress))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.POSTAL.CODE")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.zipCode))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.WEBSITE.ADDRESS")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.companyWebAddress))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.NAME")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.contactFirstName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.LAST.NAME")))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.contactLastName))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.CONTACT.PHONE.NUMBER")))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data.phoneNumber))])
                ]),
                _vm._v(" "),
                "C480" === _vm.corpCd
                  ? _c("tr", [
                      _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.EUR.APE.CODES")))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.data.apeCodes))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                0 < parseInt(_vm.data.fileLength1)
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.INSURANCE.POLICY")))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "link_attch",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile("1", _vm.data.fileName1)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "ico_attach" }),
                            _vm._v(
                              _vm._s(_vm.data.fileName1) +
                                "\n                                    "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                0 < parseInt(_vm.data.fileLength2)
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.FILE"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "link_attch",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile("2", _vm.data.fileName2)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "ico_attach" }),
                            _vm._v(
                              _vm._s(_vm.data.fileName2) +
                                "\n                                    "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "290px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d64b165", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d64b165","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/voc/RequestVocUserInfoPopup.vue
// module id = TDu/
// module chunks = 0